import { Navigate } from "react-router-dom";
import { authAPI } from "../hooks/remote/blogApi";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = authAPI.isAuthenticated();

    if (!isAuthenticated) {
        return <Navigate to="/blog-admin/login" replace />;
    }

    return children;
};

export default ProtectedRoute;

